import React, { CSSProperties, FC, ReactNode } from 'react';

import { cn } from 'utils';

import styles from './MetricProgressBar.module.scss';

type Props = {
  currentValue: ReactNode;
  totalValue: ReactNode;
  currentLabel: string;
  totalLabel: string;
  percentage: number;
  className?: string;
};

const MetricProgressBar: FC<Props> = ({
  currentValue,
  totalValue,
  currentLabel,
  totalLabel,
  percentage,
  className,
}) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

  const cssVars = {
    '--fill-width': `${clampedPercentage}%`,
  } as CSSProperties;

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.values}>
        <span className={styles.value}>{currentValue}</span>
        <span className={cn(styles.value, styles.valueEnd)}>{totalValue}</span>
      </div>
      <div className={styles.track} style={cssVars}>
        <div className={styles.fill} />
      </div>
      <div className={styles.labels}>
        <span className={styles.label}>{currentLabel}</span>
        <span className={cn(styles.label, styles.labelEnd)}>{totalLabel}</span>
      </div>
    </div>
  );
};

export default MetricProgressBar;
